<template>
	<div class="redirect-external">
		<alert-error v-if="showAlert" :textError="textError"></alert-error>
		<img v-if="!showAlert" src="../../public/img/loaders/Loader_Turquesa.gif" alt />
	</div>
</template>
<script>
import AlertError from "../components/shared/default/AlertError.vue";
import i18n from "@/plugins/i18n";
var moment = require("moment");
moment.locale("pt-br");
import { Bus } from "../event-bus.js";
export default {
	components: {
		AlertError
	},
	data() {
		return {
			showAlert: false,
			textError: "",
			serviceKey: "repense-game",
			urlParams: {},
			user: {},
			kenobyInfo: {},
		};
	},
	async created() {
		localStorage.clear();
		let self = this;
		this.urlParams = this.$route.query;

		// console.log("this.$route.query: ", this.urlParams)
		const workspaceResponse = await this.getWorkspace(this.urlParams.workspaceId)
		if(!workspaceResponse) return
		if(!this.urlParams.userId && !this.urlParams.email) return this.errorView('Erro com a url, entre em contato com a empresa responsável pelo processo seletivo')
		// não ta sendo usado a integração com a Kenoby mais
		// if(this.urlParams.kenobyInfoId){
		// 	if(!await this.verifyKenobyInfo(this.urlParams.kenobyInfoId, workspaceResponse.externalId))
		// 		return this.errorView('Erro com a url, entre em contato com a empresa responsável pelo processo seletivo')
		// 	this.user.email = this.kenobyInfo.email
		// 	this.user.name = this.kenobyInfo.name
		// } 					
		if(this.urlParams.externalId) {
			const user = await this.getUser(this.urlParams.userId)
			if(!user) return this.errorView("Usuário não encontrado")
			this.user = user
			await this.verifyVagasService(this.user.externalId, this.urlParams.externalId)
		}
		if(this.urlParams.gupyServiceId){
			const gupyService = await this.getGupyService(this.urlParams.gupyServiceId, this.urlParams.userId, this.serviceKey, workspaceResponse.externalId)
			if(!gupyService) return alert("Desculpe, houve um erro ao com a URL")
			this.user.email = gupyService.email
			this.user.name = gupyService.name
		} 
		if(this.urlParams.cieersInfoId){
			const cieersInfo = await this.getCieersInfo(this.urlParams.cieersInfoId, this.urlParams.userId)
			if(!cieersInfo) return this.errorView('Houve um erro com o endereço (url), entre em contato com a empresa responsável pelo processo seletivo')
			this.user.name = cieersInfo.name	
			this.user.email = cieersInfo.email	
		}
        
		if(this.urlParams.gupyServiceId || this.urlParams.cieersInfoId || this.urlParams.huddleIntegration || (!this.urlParams.userId && this.urlParams.email)){
			let user = {
				externalId: this.urlParams.userId,
				name: this.urlParams.name || this.user.name,
				cpf: this.urlParams.cpf,
				email: this.urlParams.email || this.user.email
			}
			for (const prop in user) if(!user[prop]) delete user[prop]
			
			user.password = "huddle123"
			if(!await this.createUser(user)) return
		}
		localStorage.setItem('user', JSON.stringify(this.user))
		localStorage.setItem('uid', this.user.id)
		localStorage.setItem('workspaceId', this.urlParams.workspaceId)
		localStorage.setItem('workspaceTitle', workspaceResponse.title)
		if(this.urlParams.externalId) localStorage.setItem('externalId', this.urlParams.externalId) //TODO: externalId do vagasService
		// if(this.urlParams.kenobyInfoId) localStorage.setItem("kenobyInfoId", this.urlParams.kenobyInfoId)
		localStorage.setItem('serviceKey', this.serviceKey)
		localStorage.setItem('applicantId', this.user.externalId)
		 

		try {
			// let colors = workspaceResponse.colors ? workspaceResponse.colors : defaultColor
			// if(!colors.theme) colors.theme = 'dark'
			localStorage.setItem("colors", JSON.stringify(await this.getCustomColors()));

			const responseGameSet = await this.$http.get( `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/game-sets?userId=${this.user.id}&workspaceId=${this.urlParams.workspaceId}` );
			// console.log("gameset: ", responseGameSet.body.id);
			let gameSet = responseGameSet.body.id;
			self.buscaGame(gameSet, this.urlParams.workspaceId);
		} catch (error) {
			//TODO: make a error message showing up instead console.log error
			// console.log(error);
			if ( error.body.response == "gameSet not found" || error.body.response == "gameSet(s) not found") {
				// localStorage.setItem("token", token);
				this.$router.push("/statement-game");
				return;
			}
			if (
				error.body.response == "workspace not found" ||
				error.body.response == "workspace(s) not found"
			) {
				this.$router.push("/not-found"); //TODO: colocar uma page de aviso
				return;
			}
			this.errorView(
				"Erro com a url, entre em contato com a empresa responsável pelo processo seletivo"
			);
		}
  	},

    methods:{
        errorView(error){
            this.textError = error
            this.showAlert = true
        },
        async getWorkspace(workspaceId){
			try {
				const { data: response } = await this.$http.get(`${process.env.VUE_APP_SERVICE_CATALOG}/workspaces/${workspaceId}`)
				const isOpen = moment(response.workspace.endDate).diff(moment().format(), 'seconds') < 0 || moment(response.workspace.startDate).diff(moment().format(), 'seconds') > 0 ? false : true
				if(!isOpen) return this.errorView('Ops, você está tentando acessar o game fora do período estipulado :/')
				i18n.locale = response.workspace.language ? response.workspace.language : "pt-br"
				localStorage.setItem("language", i18n.locale)
				return response.workspace
			} catch (error) {
				return this.errorView('Processo não encontrado, entre em contato com a empresa responsável por ele')
			}
        },
		async getCustomColors(){
            let colors = {
                primary: "#58fdf4",
                secondary: "#fe4778",
                theme: "dark",
                clientLogoPath: "",
                dark: {
                    to: "#192733",
                    from: "#001324",
                },
                light: {
                    to: "#ccc",
                    from: "#fff",
                },
            }
            try {
                // console.log("before get wsSetups")
                const responseSetups = await this.$http.get(`${process.env.VUE_APP_SERVICE_CATALOG}/ws-setups/?workspaceId=${this.urlParams.workspaceId}`);
                // console.log("responseSetups: ", responseSetups)
                if (!responseSetups.body.wsSetups.fields || !responseSetups.body.wsSetups.fields.products || !responseSetups.body.wsSetups.fields.products.repense) return colors
                if (responseSetups.body.wsSetups.fields.products.repense.colors)
                    colors = {
                        ...colors, 
                        ...responseSetups.body.wsSetups.fields.products.repense.colors,
                        theme: responseSetups.body.wsSetups.fields.products.repense.theme || 'dark',
                        clientLogoPath: responseSetups.body.wsSetups.fields.products.repense.logoPath
                    }
            } catch (error) {
                return colors
            }
            return colors
        },
		async getUser(userId){
			try {
				const userReq = await this.$http.get(`${process.env.VUE_APP_HOST_FUNCTIONS}/users/${userId}`)
				// console.log("getUser: ", userReq.data)
				return userReq.data
			} catch (error) {
				//TODO: make a error message showing up instead console.log error
				// console.error("Erro ao buscar o usuário")
				return false
			}
		},
        async createUser(user){
			// console.log("user BODY: ", user)
            try {

                const { data: response } = await this.$http.post(`${process.env.VUE_APP_HOST_FUNCTIONS}/users/no-email`,  user )
                // console.log(response)
                this.user.token = response.token
                this.user.id = response.user.id
                this.user.externalId = response.user.externalId
                this.user.name = response.user.name
				if(response.user.cpf) this.user.cpf = response.user.cpf  
				if(response.user.email) this.user.email = response.user.email  
				// console.log("createdUser: ", response)
                return true
                 
            } catch (error) {
                // console.error(error)
				this.errorView('Houve um erro com o endereço (url), entre em contato com a empresa responsável pelo processo seletivo')
                return false 
            }

        },        
		async getGupyService(gupyServiceId, userId, serviceName, workspaceExternalId) {
			try {
				const { data: gupyService } = await this.$http.get(`${process.env.VUE_APP_URL_INTEGRATION_SYSTEM}/gupy/gupy-service/${gupyServiceId}`)
				// console.log("gupyService from getGupyService: ", gupyService)
				if(gupyService.test_id != serviceName) return //TODO: make a error message showing up instead console.log error // console.error("ServiceName do gupyService incorreto")
				if(gupyService.document_id != userId) return //TODO: make a error message showing up instead console.log error // console.error("Usuário da URL diferente do gupyService")
				// if(gupyService.job_id != workspaceExternalId) return console.error("Workspace da URL diferente do gupyService")

				localStorage.setItem("gupyService", JSON.stringify(gupyService))
				localStorage.setItem("gupyServiceId", this.urlParams.gupyServiceId)
				return gupyService
			} catch (error) {
				//TODO: make a error message showing up instead console.log error
				// console.error("Error trying to verify Gupy Service: ", error)
				return false
			}
		},	
        async getCieersInfo(cieersInfoId, userExternalId){
			try {
				const { data: response } = await this.$http.get(`${process.env.VUE_APP_INTEGRATION_SYSTEM}/cieers/cieers-info/${cieersInfoId}?userExternalId=${userExternalId}`)
				// console.log("getCieersInfo: ", response)
				localStorage.setItem("cieersInfo", JSON.stringify(response))
				localStorage.setItem("cieersInfoId", this.urlParams.cieersInfoId)
				return response
			} catch (error) {
				this.errorView('Houve um erro com o endereço (url), entre em contato com a empresa responsável pelo processo seletivo')
				return false
			}
		},
        async verifyVagasService(applicantId, vagasServiceId){
			try {
				await this.$http.get(`${process.env.VUE_APP_INTEGRATION_SYSTEM}/vagas/vagas-service/?externalId=${vagasServiceId}&serviceKey=${this.serviceKey}&applicantId=${applicantId}`)
				// console.log("verifyVagasService: ", response)
				return true
			} catch (error) {
				this.errorView('Houve um erro com o endereço (url), entre em contato com a empresa responsável pelo processo seletivo')
				return false
			}
		},
		// não ta sendo usado a integração com a Kenoby mais
		// async verifyKenobyInfo(kenobyInfoId, workspaceExternalId){
		// 	const userId = this.urlParams.userId || this.urlParams.externalUserId
		// 	try {
		// 		const { data: response } = await this.$http.get(`${process.env.VUE_APP_INTEGRATION_SYSTEM}/kenoby/kenoby-info/${kenobyInfoId}`)
		// 		this.kenobyInfo = response
		// 		// console.log("this.kenobyInfo: ", this.kenobyInfo)
		// 		if(userId != response.applicant || workspaceExternalId != response.position) return false
		// 		return true
		// 	} catch (error) {
		// 		// console.error("error trying to get Kenoby Info")
		// 		this.errorView('Houve um erro com o endereço (url), entre em contato com a empresa responsável pelo processo seletivo')
		// 		return false
		// 	}
		// },
        buscaGame(gameSetId, workspaceId){
            const self = this
            self.$http.get(`${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}/solo-games/game-set-games?gameSetId=${gameSetId}`)
                .then(response => {
                    if(response.body.soloGames.length == 0){
                        this.$router.push('/statement-game')
                        return
                    }
                    
                    if(response.body.soloGames.length > 4){
                        self.$router.push('/dashboard')
                        return
                    }

                    const now = moment(response.body.now)
                    self.$store.commit('setNowState', now)
                    
                    const lastSolo = self.defineLastSolo(response.body.soloGames)
                    const secondsDiff = moment(lastSolo.createdAt).diff(now, "seconds");
                    localStorage.setItem('soloGameId', lastSolo.id)
                    localStorage.setItem('secondsDiff', secondsDiff)
                    localStorage.setItem('gameSetId', gameSetId)
                    self.$store.commit('setSoloGameRequest', response.body.soloGames)
                    Bus.$emit('saveSoloGame', response.body.soloGames)
                    if(response.body.soloGames.length == 4 && lastSolo.status != 'inprogress'){
                        self.$router.push('/dashboard')
                        return
                    }
                    if(lastSolo.status == 'inprogress'){
                        self.$router.push('/solo-game')
                        return
                    }
                    if(lastSolo.status == 'timeout' || lastSolo.status == 'hit' || lastSolo.status == 'giveup'){
                        localStorage.setItem('secondsDiff', '')
                        self.$router.push('/')
                        return
                        }
                    
                }).catch(error => {
					//TODO: make a error message showing up instead console.log error
                    // console.log(error)
                })
        },
        defineLastSolo(soloGames){
            if(soloGames.length < 2) return soloGames[0]
            const lastSolo = soloGames.reduce((a, b) => {
                return a.createdAt > b.createdAt ? a : b
            })
            return lastSolo
        }
    }
};
</script>
<style lang="scss" scoped>
.redirect-external {
  height: 100%;
  width: 100%;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #404040;

  .preloader_images {
    visibility: hidden;
  }

  img {
    height: 120px;
  }
}
</style>
